import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const FundamentalsPanel = ({balancesheets}) => {

    const getAltmanZScore = (balancesheet) => {
        const A = balancesheet.working_capital / balancesheet.total_assets;
        const B = balancesheet.retained_earnings / balancesheet.total_assets;

        // Check next three
        const C = balancesheet.earningsBeforeInterestAndTaxes / balancesheet.total_assets;
        const D = balancesheet.marketCap / balancesheet.total_assets;
        const E = balancesheet.revenue / balancesheet.total_assets;

        const altmanZScore = 1.2 * A + 1.4 * B + 3.3 * C + 0.6 * D + 1.0 * E;
        return altmanZScore;
    }

    const zScores = balancesheets.map((yearData) => ({
        date: new Date(yearData.date),
        zScore: getAltmanZScore(yearData),
    }));

    const data = {
        labels: zScores.map((data) => data.date),
        datasets: [
          {
            label: 'Altman Z-Score',
            data: zScores.map((data) => data.zScore),
            fill: false,
            backgroundColor: 'rgba(75,192,192,0.4)',
            borderColor: 'rgba(75,192,192,1)',
            tension: 0.1,
          },
        ],
    };

    const options = {
        scales: {
          x: {
            type: 'time',
            time: {
              unit: 'year',
              tooltipFormat: 'yyyy', // Format for tooltip
              displayFormats: {
                year: 'yyyy', // Format for x-axis labels
              },
            },
            title: {
              display: true,
              text: 'Year',
            },
          },
          y: {
            title: {
              display: true,
              text: 'Altman Z-Score',
            },
          },
        },
    };

    return (
        <>
            {balancesheets && (
                <Box>
                    {/* <Text>Altman Z-Score: {getAltmanZScore(balancesheet)}</Text> */}
                    <Text>Altman Z-Score Over the Years</Text>
                    <Bar data={data} options={options} />
                </Box>
            )}
        </>
    );
}

export default FundamentalsPanel;